import { z } from 'zod';
import { MarketCountryCode } from '../ace_index';

export const GetAgentAssignmentReqSchema = z.object({
  AgentID: z.string(),
});

export type GetAgentAssignmentReq = z.infer<typeof GetAgentAssignmentReqSchema>;

export enum AssignmentType {
  SecuredLoan = 'secured_loan',
  UnsecuredLoan = 'unsecured_loan',
  UnsecuredLoanWithOwnership = 'unsecured_loan_w_ownership',
}

export const GetAgentAssignmentResSchema = z.object({
  AssignmentTypes: z.array(z.nativeEnum(AssignmentType)).nullable(),
  Available: z.boolean(),
  ClientID: z.string().uuid(),
  MarketCountry: z.nativeEnum(MarketCountryCode),
});

export type GetAgentAssignmentRes = z.infer<typeof GetAgentAssignmentResSchema>;

export const PostAgentAssignmentReqSchema = z.object({
  Count: z.number().optional(),
});

export type PostAgentAssignmentReq = z.infer<
  typeof PostAgentAssignmentReqSchema
>;

const ApplicationSchema = z.object({
  AssignedAgentID: z.string(),
  AssignmentType: z.string(),
  LoanApplicationID: z.string().uuid(),
  MarketCountry: z.string(),
  ProcessedAt: z.string(),
});

export const PostAgentAssignmentResSchema = z.object({
  Applications: z.array(ApplicationSchema).nullable(),
  Message: z.string().nullable(),
});

export type PostAgentAssignmentRes = z.infer<
  typeof PostAgentAssignmentResSchema
>;

export const FindAgentsReqSchema = z.object({
  market_country: z.nativeEnum(MarketCountryCode),
  assignment_type: z.nativeEnum(AssignmentType).optional(),
  available: z.boolean().optional(),
});

export type FindAgentsReq = z.infer<typeof FindAgentsReqSchema>;

export const AgentSchema = z.object({
  ClientID: z.string().uuid(),
  MarketCountry: z.nativeEnum(MarketCountryCode),
  AssignmentTypes: z.array(z.nativeEnum(AssignmentType)).nullable(),
  Available: z.boolean(),
});

export type Agent = z.infer<typeof AgentSchema>;

export const FindAgentsResSchema = z.object({
  Items: z.array(AgentSchema).nullable(),
});

export type FindAgentsRes = z.infer<typeof FindAgentsResSchema>;

export const SetAgentAvailableReqSchema = z.object({
  AgentID: z.string(),
});

export type SetAgentAvailableReq = z.infer<typeof SetAgentAvailableReqSchema>;

export const SetAgentAvailableResSchema = z.object({
  NewAssignedApplications: z.array(ApplicationSchema).nullable(),
});

export type SetAgentAvailableRes = z.infer<typeof SetAgentAvailableResSchema>;

export const SetAgentUnavailableReqSchema = z.object({
  AgentID: z.string(),
});

export type SetAgentUnavailableReq = z.infer<
  typeof SetAgentUnavailableReqSchema
>;

export const SetAgentUnavailableResSchema = z.object({});

export type SetAgentUnavailableRes = z.infer<
  typeof SetAgentUnavailableResSchema
>;

export const GetAssignmentApplicationReqSchema = z.object({
  ApplicationID: z.string().uuid(),
});

export type GetAssignmentApplicationReq = z.infer<
  typeof GetAssignmentApplicationReqSchema
>;

export const GetAssignmentApplicationResSchema = z.object({
  AssignedAgentID: z.string(),
  AssignmentType: z.nativeEnum(AssignmentType),
  CreatedAt: z.string(),
  LoanApplicationID: z.string().uuid(),
  MarketCountry: z.string(),
  ProcessedAt: z.string(),
});

export type GetAssignmentApplicationRes = z.infer<
  typeof GetAssignmentApplicationResSchema
>;

export const SetApplicationProcessedReqSchema = z.object({
  ApplicationID: z.string().uuid(),
});

export type SetApplicationProcessedReq = z.infer<
  typeof SetApplicationProcessedReqSchema
>;

export const SetApplicationProcessedResSchema = z.object({
  NewAssignedApplications: z.array(ApplicationSchema).nullable(),
});

export type SetApplicationProcessedRes = z.infer<
  typeof SetApplicationProcessedResSchema
>;

export const PatchApplicationAssignmentReqSchema = z.object({
  AssignedAgentID: z.string(),
  AssignmentType: z.string().optional(),
  MarketCountry: z.string().optional(),
  ProcessedAt: z.string().optional(),
});

export type PatchApplicationAssignmentReq = z.infer<
  typeof PatchApplicationAssignmentReqSchema
>;

export const GetAgentAssignmentsListV3ReqSchema = z.object({
  AgentID: z.string(),
});

export type GetAgentAssignmentsListV3Req = z.infer<
  typeof GetAgentAssignmentsListV3ReqSchema
>;

export const GetAgentAssignmentsListV3ResSchema = z.array(ApplicationSchema);

export type GetAgentAssignmentsListV3Res = z.infer<
  typeof GetAgentAssignmentsListV3ResSchema
>;
